module.exports = __webpack_public_path__ + "img/progress-login-bg.96761ef2.jpg";